import React, { Component } from 'react';
import { Helmet } from "react-helmet";

import Banner from './components/Banner';
import Advantage from './components/Advantage';
import Guide from './components/Guide';
import Start from './components/Start';

class Home extends Component {
  render() {
    return (
      <div className="Home">
        <Helmet>
          <title>Welcome to QbatesApp</title>
          <meta name="description" content="Get Cashback for Every Purchase You Made" />
        </Helmet>
        <Banner/>
        <Advantage/>
        <Guide/>
        <Start/>
      </div>
    );
  }
}

export default Home;


// WEBPACK FOOTER //
// ./src/Containers/Home/Home.js